<template>
    <router-view></router-view>
</template>

<script>
    export default {
        name: 'App',
        //watch: {
        //    $route(to, from) {
        //        for (var i = 0; i < to.matched.length; i++) {
        //            var route = to.matched[i];
        //            if (route.meta && route.meta.param) {
        //                route.meta.label = '#' + to.params[route.meta.param];
        //            }
        //        }
        //    }
        //}
    }
</script>

<style lang="scss">

    /* Import Main styles for this application */
    @import '../node_modules/bootstrap-vue/dist/bootstrap-vue.css';
    @import 'assets/scss/style';
</style>
